import { render, staticRenderFns } from "./EditOderServicioColumn.vue?vue&type=template&id=88ff6aac&scoped=true&"
import script from "./EditOderServicioColumn.vue?vue&type=script&lang=ts&"
export * from "./EditOderServicioColumn.vue?vue&type=script&lang=ts&"
import style0 from "./EditOderServicioColumn.vue?vue&type=style&index=0&id=88ff6aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ff6aac",
  null
  
)

export default component.exports